<template>
    <v-container fluid class="pa-0 mb-offset">
        <v-row class="ma-0">
            <revenue-chart
                :model-id='id'
                model-key="company_id"
                url="ddtsrevenuestats"
            ></revenue-chart>                    
        </v-row>
        <v-row class="pt-4 ma-0" v-if="$store.getters.checkSettings('show_sold_products_costs')">
            <sold-products
                :model-id='id'
                type="costs"
            ></sold-products>
        </v-row>
        <v-row class="pt-4 ma-0" v-if="$store.getters.checkSettings('show_sold_products_revenue')">
            <sold-products
                :model-id='id'
                type="revenue"
            ></sold-products>
        </v-row>  
    </v-container>
</template>

<script>
    import RevenueChart from '@/components/common/RevenueChart'
    import SoldProducts from '@/components/common/SoldProducts'

    export default {
        name: 'analitycs-index',
        components: {
            SoldProducts,
            RevenueChart,
        },        
        props: {
            id: Number,
        },

        data() {
            return {
            }
        },

        created() {
            this.$store.commit('endProgress')
        }
    }
</script>

<style>

</style>